import { TFunction } from 'react-i18next';
import { HistoryAction } from 'rete-history-plugin';
import { NodeData } from './dataNode';
import { CustomNodeEditor, processData } from './rete';
import { cloneGraphNodes } from './utils';

export class ArielAiGraphAction implements HistoryAction {
  private editor: CustomNodeEditor;
  private previousNodes: NodeData[];
  private nextNodes: NodeData[];
  private t: TFunction;
  private languageCode: string;

  constructor(
    editor: CustomNodeEditor,
    previousNodes: NodeData[],
    nextNodes: NodeData[],
    t: TFunction,
    languageCode: string,
  ) {
    this.editor = editor;
    this.previousNodes = cloneGraphNodes(previousNodes);
    this.nextNodes = cloneGraphNodes(nextNodes);
    this.t = t;
    this.languageCode = languageCode;
  }

  async undo(): Promise<void> {
    await processData(
      cloneGraphNodes(this.previousNodes),
      this.editor,
      this.t,
      this.languageCode,
      false,
      undefined,
      true,
    );
  }

  async redo(): Promise<void> {
    await processData(cloneGraphNodes(this.nextNodes), this.editor, this.t, this.languageCode, false, undefined, true);
  }
}
